<template>
  <div
    v-if="popperOptions"
  >
    <pop-over
      :options="popperOptionsComputed"
    >
      <span
        :class="computedClasses"
      >
        {{ text }}
      </span>
    </pop-over>
  </div>
  <span
    v-else
    :class="computedClasses"
  >
    {{ text }}
  </span>
</template>
<script>
import PopOver from '@/components/helpers/DataDisplay/PopOver'
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    popperOptions: {
      type: Object,
      default: null
    }
  },
  components: {
    PopOver
  },
  computed: {
    popperOptionsComputed() {
      if (!this.popperOptions) { return {} }
      return {
        content: this.popperOptions.content,
        options: this.popperOptions
      }
    },
    computedClasses() {
      let classes = ["sensual-badge"]
      if (this.color === 'yellow') {
        classes.push('yellow')
      } else if (this.color === 'green' ){
        classes.push('green')
      } else if (this.color === 'red' ){
        classes.push('red')
      } else if (this.color === 'grey' ){
        classes.push('grey')
      } else if (this.color === 'grey-dark' ){
        classes.push('grey-dark')
      } else if (this.color === 'dark' ){
        classes.push('dark')
      } else if (this.color === 'indigo' ){
        classes.push('indigo')
      } else if (this.color === 'blue' ){
        classes.push('blue')
      }
      return classes
    }
  }
}
</script>




// WEBPACK FOOTER //
// SensualBadge.vue?812a7370